module.exports = __webpack_public_path__ + "img/dataGrey.af620531.svg";